import { render } from "./ReportPage.vue?vue&type=template&id=0ca26674&ts=true"
import script from "./ReportPage.vue?vue&type=script&lang=ts"
export * from "./ReportPage.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/QLTS/QLTS_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__